import { isSuggestOptionTag } from "../../utils/autocomplete/SuggestOption.type";
import { MentionsPlugin } from "../../../sked-editor/social-mention/mention-plugin";
import { SuggestFunc } from "../types";
import { SkedMentionBox, SkedMentionItem } from "./sked-mention-box";
import { useRef } from "react";
import { MentionPluginInstance } from "../../../sked-editor/social-mention/types";
import { PUNCTUATION } from "../../../sked-editor/type-ahead/type-ahead-plugin";

export const AtMentionSearchPlugin = ({
  lookupFunc,
  onRemoveItem,
}: {
  lookupFunc: SuggestFunc;
  onRemoveItem: (item: SkedMentionItem) => Promise<void>;
}) => {
  const pluginRef = useRef<MentionPluginInstance>(null);
  return (
    <MentionsPlugin
      pluginRef={pluginRef}
      menuBoxBehavior={{
        nodeConversion: {
          type: "plain-text",
          convertFunc: (item) => `@${item.key}`,
          trailingSpace: true,
        },

        dataFetcher: async (
          lookupText: string | null | undefined
        ): Promise<SkedMentionItem[]> => {
          const rs = await lookupFunc(lookupText || "");
          return rs
            .filter((c) => isSuggestOptionTag(c))
            .filter((c) => c.value.length > 1)
            .map((c) => ({ key: c.value, displayName: `@${c.value}` }));
        },
        renderMenuBox: (props, { lookupText }) => {
          return (
            <SkedMentionBox
              {...props}
              onRemoveItem={async (item) => {
                await onRemoveItem(item);
                pluginRef.current?.reload();
              }}
              headingText="Search accounts"
              infoTooltip="Only previously mentioned accounts are shown. Enter the correct handle to mention others."
              highlightBehavior={{
                matchingOn: "start",
                searchText: lookupText ? `@${lookupText}` : undefined,
              }}
              displayConfig={{
                showRemove: true,
              }}
            />
          );
        },

        maxItemsToShow: 100,
      }}
      lookupConfig={{
        allowWhitespace: false,
        trigger: "@",
        minLength: 0,
        maxLength: 100,
        typeDebounceTime: 200,
        punctuation: PUNCTUATION.replace(".", ""),
      }}
    />
  );
};
